import React from 'react';
import type { HTMLProps } from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import { ButtonSize } from '../../../types/variants';

import styles from '../textField.module.scss';

type Props = { size?: ButtonSize; hasError?: boolean; isDisabled?: boolean } & Omit<
  HTMLProps<HTMLDivElement>,
  'size' | 'isDisabled'
>;

const InputWrapper = (props: Props) => {
  const { className, size = ButtonSize.Medium, children, isDisabled, hasError, ...rest } = props;

  const classNames = cx(
    className,
    styles.textField,
    styles[toCamelCase('textField', size)],
    hasError ? styles[toCamelCase('textField', 'error')] : '',
    isDisabled ? styles[toCamelCase('textField', 'disabled')] : '',
  );

  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  );
};

export default InputWrapper;
